query CmsEntryBaseQuery($uri: [String]!, $site: [String]!) {
  entryCount(uri: $uri, site: $site)
  entry(uri: $uri, site: $site) {
    ... on products_Entry {
      useMinimalLayout
    }
  }
}
